import {
  DEFAULT_PHONE_COUNTRY,
  formatPhoneDisplayParts,
  formatPhoneForDisplay,
  type CountryCode,
} from '@wapharma/shared';
import { cx } from '../utils/cx.js';
import { PhoneFlag } from './PhoneFlag.js';
import styles from './PhoneDisplay.module.css';

export type PhoneDisplayProps = {
  value: string | null | undefined;
  defaultCountry?: CountryCode;
  className?: string;
  emptyPlaceholder?: string;
};

export function PhoneDisplay({
  value,
  defaultCountry = DEFAULT_PHONE_COUNTRY,
  className,
  emptyPlaceholder = '—',
}: PhoneDisplayProps) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return <>{emptyPlaceholder}</>;

  const parts = formatPhoneDisplayParts(trimmed, defaultCountry);
  if (!parts) {
    return (
      <span className={cx(styles.root, styles.fallback, className)}>
        {formatPhoneForDisplay(trimmed, defaultCountry)}
      </span>
    );
  }

  return (
    <span className={cx(styles.root, className)}>
      <PhoneFlag country={parts.country} />
      <span className={styles.dialCode}>{parts.dialCode}</span>
      <span className={styles.national}>{parts.national}</span>
    </span>
  );
}
